import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const EightFtIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-eightFt"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M26,0 L10,0 C7.79071525,0 6,1.79071525 6,4 L6,30 C6,32.2092847 7.79071525,34 10,34 L26,34 C28.2092847,34 30,32.2092847 30,30 C30,27.7907153 28.2092847,26 26,26 L16,26 C14.8952847,26 14,25.1047153 14,24 L14,10 C14,8.89528475 14.8952847,8 16,8 L26,8 C28.2092847,8 30,6.20928475 30,4 C30,1.79071525 28.2092847,0 26,0 Z M10,2 L26,2 C27.1047153,2 28,2.89528475 28,4 C28,5.10471525 27.1047153,6 26,6 L16,6 C13.7907153,6 12,7.79071525 12,10 L12,24 C12,26.2092847 13.7907153,28 16,28 L26,28 C27.1047153,28 28,28.8952847 28,30 C28,31.1047153 27.1047153,32 26,32 L10,32 C8.89528475,32 8,31.1047153 8,30 L8,4 C8,2.89528475 8.89528475,2 10,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M24.5,7 L16.5,7 C14.5668576,7 13,8.56685763 13,10.5 L13,23.5 C13,25.4331424 14.5668576,27 16.5,27 L24.5,27 C26.4331424,27 28,25.4331424 28,23.5 L28,10.5 C28,8.56685763 26.4331424,7 24.5,7 Z M16.5,8 L24.5,8 C25.8808576,8 27,9.11914237 27,10.5 L27,23.5 C27,24.8808576 25.8808576,26 24.5,26 L16.5,26 C15.1191424,26 14,24.8808576 14,23.5 L14,10.5 C14,9.11914237 15.1191424,8 16.5,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="13.5 17 27.5 17 27.5 16 13.5 16"
        />
        <path
          d="M31.4623 16.1565C30.8463 16.5315 30.8463 17.4685 31.4623 17.8435L33.5373 19.1055 35.6133 20.3685C36.2293 20.7425 37.0003 20.2745 37.0003 19.5245L37.0003 17.0005 37.0003 14.4755C37.0003 13.7255 36.2293 13.2575 35.6133 13.6315L33.5373 14.8945 31.4623 16.1565ZM50.5377 16.1565C51.1537 16.5315 51.1537 17.4685 50.5377 17.8435L48.4627 19.1055 46.3867 20.3685C45.7707 20.7425 44.9997 20.2745 44.9997 19.5245L44.9997 17.0005 44.9997 14.4755C44.9997 13.7255 45.7707 13.2575 46.3867 13.6315L48.4627 14.8945 50.5377 16.1565Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="36.5 18 45.5 18 45.5 16 36.5 16"
        />
        <path
          d="M58,4 L56,4 C54.8957153,4 54,4.89571525 54,6 L54,28 C54,29.1042847 54.8957153,30 56,30 L58,30 C59.1042847,30 60,29.1042847 60,28 L60,6 C60,4.89571525 59.1042847,4 58,4 Z M56,6 L58,6 L58,28 L56,28 L56,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M60.5,11.5 L59.5,11.5 C58.6718576,11.5 58,12.1718576 58,13 L58,21 C58,21.8281424 58.6718576,22.5 59.5,22.5 L60.5,22.5 C61.3281424,22.5 62,21.8281424 62,21 L62,13 C62,12.1718576 61.3281424,11.5 60.5,11.5 Z M59.5,12.5 L60.5,12.5 C60.7758576,12.5 61,12.7241424 61,13 L61,21 C61,21.2758576 60.7758576,21.5 60.5,21.5 L59.5,21.5 C59.2241424,21.5 59,21.2758576 59,21 L59,13 C59,12.7241424 59.2241424,12.5 59.5,12.5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
